module.exports = __webpack_public_path__ + "1-23.png?01db5b165d0dd946ea5a4d7ea7a23bff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1-23.png
// module id = 100
// module chunks = 0